{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Cube",
			"scale": [1.5235869884490967, 1.90250825881958, 3.2655246257781982],
			"translation": [0.23386573791503906, 1.9743869304656982, 0]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.067",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.10527865588665009, 0.0952981635928154, 0.09305760264396667, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.8779527544975281
			}
		}
	],
	"meshes": [
		{
			"name": "Cube",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 516,
			"max": [1.81666898727417, 5.64900016784668, 1.5099607706069946],
			"min": [-1, -1, -1.4730582237243652],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 516,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 516,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 1368,
			"type": "SCALAR"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 6192,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 6192,
			"byteOffset": 6192,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 4128,
			"byteOffset": 12384,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2736,
			"byteOffset": 16512,
			"target": 34963
		}
	],
	"buffers": [
		{
			"byteLength": 19248,
			"uri": "rockpile.bin"
		}
	]
}
